
import { warehousepermissions, warehousespermissions } from 'rest/urls'
import { AccessType } from './useAccessParams'
import { Form } from '../MagAccess/NewAccess'
import { isValidPhone } from 'utils/phone'
import { DELETE, POST } from 'rest/request'
import { useState } from 'react'

const useSendingForm = (
  form: Form,
  action: AccessType,
  callback: basic.BasicFunc,
  permissionId?: string
) => {
  const [errors, setErrors] = useState<basic.Errors>({})
  const [isSending, setSending] = useState(false)

  const validateForm = () => {
    if (isSending) return
    const isPhoneOk = isValidPhone(form.prefix, form.phone)
    const dateValues = action === 'time-access' ? (form.date && form.time) : true
    if (isPhoneOk && form.name.length > 1 && form.warehouseIds.length > 0 && dateValues) {
      if (Object.keys(errors).length > 0) setErrors({})
      sendForm()

    } else {
      const newErrors: basic.Errors = {}
      if (form.name.length < 2) newErrors.name = 'Wpisz imię i nazwisko'
      if (!isPhoneOk) newErrors.phone = form.phone ? 'Niewłaściwy numer telefonu' : 'Wpisz numer telefonu'
      if (!form.warehouseIds || form.warehouseIds.length === 0) newErrors.warehouseIds = 'Dodaj co najmniej 1 magazyn'
      if (action === 'time-access' && !form.date) newErrors.date = 'Wpisz datę'
      if (action === 'time-access' && !form.time) newErrors.time = 'Wpisz godzinę'
      setErrors(newErrors)
    }
  }

  const sendForm = async () => {
    setSending(true)
    try {
      const url = permissionId
        ? `${warehousepermissions}/${permissionId}`
        : warehousespermissions
      const body = action === 'one-time-access'
        ? { ...form, oneTime: true, functions: ['entry'] }
        : form
      const response = await POST(url, { body })
      if (permissionId ? response?.data : response?.result === 'ok') {
        callback()
      } else {
        throw new Error('Wrong response')
      }
    } catch (error) {
      setSending(false)
    }
  }

  const remove = async () => {
    if (isSending || !permissionId) return
    setSending(true)
    try {
      const response = await DELETE(`${warehousepermissions}/${permissionId}`)
      if (response) {
        callback()
      } else {
        throw new Error('Wrong response')
      }
    } catch (error) {
      setSending(false)
    }
  }

  return {
    errors,
    isSending,
    remove,
    validateForm
  }
}

export default useSendingForm